<li hlmSidebarMenuItem hlmPopover align="start" sideOffset="5" (stateChanged)="onPopoverStateChanged($event)">
  <button hlmSidebarMenuButton hlmPopoverTrigger tooltip="Notifications">
    <ng-icon name="lucideBell" />
    <span>Notifications</span>
  </button>
  @if (unreadCount() > 0) {
    <span hlmSidebarMenuBadge>{{ unreadCount() }}</span>
  }

  <hlm-popover-content class="w-[420px] max-h-[600px] gap-0 p-0" *hlmPopoverPortal="let ctx">
    <div class="border-b p-3">
      <hlm-popover-header>
        <div hlmPopoverTitle>Notifications</div>
      </hlm-popover-header>
    </div>

    <div class="flex-1 overflow-y-auto max-h-[480px]" (scroll)="onScroll($event)">
      @if (loading() && notifications().length === 0) {
        <div class="flex items-center justify-center py-12">
          <hlm-spinner />
        </div>
      } @else if (notifications().length === 0) {
        <div class="flex flex-col items-center justify-center px-4 py-12 text-center">
          <ng-icon name="lucideBellOff" class="mb-3 text-4xl text-muted-foreground" />
          <p class="m-0 text-muted-foreground">No notifications</p>
        </div>
      } @else {
        @for (message of notifications(); track message.id) {
          <button
            type="button"
            (click)="onNotificationClick(message)"
            [class.bg-muted]="isUnread(message)"
            class="w-full cursor-pointer border-b px-4 py-3 text-left transition-colors hover:bg-accent"
          >
            <div class="flex items-start gap-3">
              <ng-icon [name]="getNotificationIcon(message).name" class="text-lg" [class]="getNotificationIcon(message).color" />
              <div class="min-w-0 flex-1">
                <p class="m-0 mb-1 text-sm wrap-break-word" [class.font-semibold]="isUnread(message)">
                  {{ getNotificationMessage(message) }}
                </p>
                <span class="text-xs text-muted-foreground">
                  {{ message.sentDate | date: 'MMM d, y, h:mm a' }}
                </span>
              </div>
              @if (isUnread(message)) {
                <div class="mt-1 size-2 shrink-0 rounded-full bg-primary"></div>
              }
            </div>
          </button>
        }

        @if (loading()) {
          <div class="flex items-center justify-center py-4">
            <hlm-spinner />
          </div>
        }
      }
    </div>
  </hlm-popover-content>
</li>
